import { Reveal } from "@/components/Reveal";

const ITEMS = [
    { num: "01", title: "Experiência Personalizada", desc: "Cada evento é pensado de acordo com o perfil dos clientes.", testid: "manifesto-01" },
    { num: "02", title: "Equipe Profissional", desc: "Músicos, DJs, técnicos e profissionais selecionados.", testid: "manifesto-02" },
    { num: "03", title: "Produção Integrada", desc: "Menos fornecedores para administrar e maior alinhamento entre todas as etapas.", testid: "manifesto-03" },
    { num: "04", title: "Padrão LC", desc: "Organização, estética e excelência do primeiro contato até o último minuto do evento.", testid: "manifesto-04" },
    { num: "05", title: "Experiências Completas", desc: "Cerimônia, recepção, DJ, música ao vivo e entretenimento integrados.", testid: "manifesto-05" },
];

const Manifesto = () => (
    <section data-testid="manifesto-section" className="bg-white px-6 md:px-12 py-28 md:py-40 border-t border-black/10">
        <div className="max-w-7xl mx-auto">
            <Reveal>
                <p className="text-[10px] tracking-[0.45em] uppercase text-[#6A2022] mb-8" data-testid="manifesto-label">
                    Por que LC Production
                </p>
            </Reveal>
            <Reveal delay={0.1}>
                <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold uppercase leading-[0.95] tracking-tight max-w-5xl" data-testid="manifesto-headline">
                    Tudo que o seu evento precisa.{" "}
                    <span className="font-editorial italic font-light normal-case text-[#6A2022]">
                        Em um só lugar.
                    </span>
                </h2>
            </Reveal>

            <div className="mt-20 md:mt-28">
                {ITEMS.map((item, i) => (
                    <Reveal key={item.num} delay={i * 0.08}>
                        <div
                            data-testid={item.testid}
                            className="group grid grid-cols-12 gap-4 md:gap-8 items-baseline border-t border-black/10 last:border-b py-8 md:py-10 transition-[padding] duration-500 hover:pl-4 md:hover:pl-8"
                        >
                            <span className="col-span-2 md:col-span-1 font-editorial italic font-light text-4xl md:text-5xl text-[#6A2022]">
                                {item.num}
                            </span>
                            <h3 className="col-span-10 md:col-span-5 text-xl md:text-3xl font-extrabold uppercase tracking-tight text-[#0A0A0A] group-hover:text-[#6A2022] transition-colors duration-300">
                                {item.title}
                            </h3>
                            <p className="col-span-10 col-start-3 md:col-span-5 md:col-start-8 text-sm md:text-base text-[#0A0A0A]/55 leading-relaxed">
                                {item.desc}
                            </p>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);

export default Manifesto;
